import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    '& div': {
      outline: 'none',
    },
    '& a': {
      transition: '0.2s linear',
      '&:focus': {
        outline: 'none',
        backgroundColor: '#2A2E4329',
      },
    },
  },
  carrossel: {
    position: 'relative',
  },
  buttons: {
    position: 'absolute',
    top: '30%',
    width: 20,
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
  },
  slideContainer: {
    height: '190px',
  },
  slideCard: {
    display: 'flex !important',
    flexDirection: 'column',
    width: '95%',
    maxWidth: 200,
  },
  image: {
    position: 'relative',
    width: '100%',
    height: 115,
    backgroundColor: '#FFFFFF',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    border: '1px solid #707070',
    borderRadius: '10px',
    [theme.breakpoints.down('sm')]: {
      height: 95,
    },
  },
  draft: {
    position: 'absolute',
    top: 6,
    left: 6,
    backgroundColor: '#4D4F5C',
    color: '#FFFFFF',
  },
  text: {
    padding: '0 4px',
    marginTop: 10,
    textAlign: 'center',
    fontWeight: 600,
  },
}));
